import loadable from '@loadable/component';
import { Navigate } from 'react-router-dom';

import { DEFAULT_INIT_PAGE } from '@/config';

import { routes } from './routes';

const BaseLayout = loadable(() => import('../BaseLayoutV2'));

const Account = loadable(() => import('@/pages/Account'));
const Home = loadable(() => import('@/pages/Home'));
const Login = loadable(() => import('@/pages/Member/Login/index'));
const FindAccount = loadable(() => import('@/pages/Member/FindAccount'));
const FindIdSuccess = loadable(() => import('@/pages/Member/FindIDSuccess'));
const NewPWD = loadable(() => import('@/pages/Member/NewPWD'));

const UserList = loadable(() => import('@/pages/User/List'));
const UserCreate = loadable(() => import('@/pages/User/Create'));
// J: Create with react-hook-form
const UserCreateRHF = loadable(() => import('@/pages/User/CreateRHF'));
const UserDetail = loadable(() => import('@/pages/User/Detail'));
const UserEdit = loadable(() => import('@/pages/User/Edit'));
// J: Edit with react-hook-form
const UserEditRHF = loadable(() => import('@/pages/User/EditRHF'));

const RoleList = loadable(() => import('@/pages/Role/List'));
const RoleCreate = loadable(() => import('@/pages/Role/Create'));
const RoleDetail = loadable(() => import('@/pages/Role/Detail'));
const RoleEdit = loadable(() => import('@/pages/Role/Edit'));

const FunctionList = loadable(() => import('@/pages/Function/List'));
const FunctionCreate = loadable(() => import('@/pages/Function/Create'));
const FunctionDetail = loadable(() => import('@/pages/Function/Detail'));
const FunctionEdit = loadable(() => import('@/pages/Function/Edit'));

const MenuList = loadable(() => import('@/pages/Menu/List'));
const MenuCreate = loadable(() => import('@/pages/Menu/Create'));
const MenuDetail = loadable(() => import('@/pages/Menu/Detail'));
const MenuEdit = loadable(() => import('@/pages/Menu/Edit'));

const ResourceList = loadable(() => import('@/pages/Resource/List'));
const ResourceCreate = loadable(() => import('@/pages/Resource/Create'));
const ResourceDetail = loadable(() => import('@/pages/Resource/Detail'));
const ResourceEdit = loadable(() => import('@/pages/Resource/Edit'));

const GroupCodeList = loadable(() => import('@/pages/GroupCode/List'));
const GroupCodeCreate = loadable(() => import('@/pages/GroupCode/Create'));
// J: Create with react-hook-form
const GroupCodeCreateRHF = loadable(() => import('@/pages/GroupCode/CreateRHF'));
const GroupCodeDetail = loadable(() => import('@/pages/GroupCode/Detail'));
const GroupCodeEdit = loadable(() => import('@/pages/GroupCode/Edit'));
// J: Update with react-hook-form
const GroupCodeEditRHF = loadable(() => import('@/pages/GroupCode/EditRHF'));

const DetailCodeList = loadable(() => import('@/pages/DetailCode/List'));
const DetailCodeCreate = loadable(() => import('@/pages/DetailCode/Create'));
// J: Create with react-hook-form
const DetailCodeCreateRHF = loadable(() => import('@/pages/DetailCode/CreateRHF'));
const DetailCodeDetail = loadable(() => import('@/pages/DetailCode/Detail'));
const DetailCodeEdit = loadable(() => import('@/pages/DetailCode/Edit'));
// J: Update with react-hook-form
const DetailCodeEditRHF = loadable(() => import('@/pages/DetailCode/EditRHF'));

const Custom404 = loadable(() => import('@/pages/Error/404'));

const SysSettingList = loadable(() => import('@/pages/SysSetting/List'));
const SysSettingDetail = loadable(() => import('@/pages/SysSetting/Detail'));
const SysSettingEdit = loadable(() => import('@/pages/SysSetting/Edit'));
const SysSettingCreate = loadable(() => import('@/pages/SysSetting/Create'));

const OrganizationList = loadable(() => import('@/pages/Organization/List'));
const OrganizationChart = loadable(() => import('@/pages/Organization/Chart'));
// const OrganizationCreate = loadable(() => import('@/pages/Organization/Create'));
const OrganizationCreateRHF = loadable(() => import('@/pages/Organization/CreactRHF'));
const OrganizationDetail = loadable(() => import('@/pages/Organization/Detail'));
// const OrganizationEdit = loadable(() => import('@/pages/Organization/Edit'));
const OrganizationEditRHF = loadable(() => import('@/pages/Organization/EditRHF'));

const ServersList = loadable(() => import('@/pages/Servers/List'));
const ServersDetail = loadable(() => import('@/pages/Servers/Detail'));
const ServersEdit = loadable(() => import('@/pages/Servers/Edit'));
const ServersCreate = loadable(() => import('@/pages/Servers/Create'));
// J: Create with react-hook-form
const ServersCreateRHF = loadable(() => import('@/pages/Servers/CreateRHF'));

const LicenseList = loadable(() => import('@/pages/License/List'));
const LicenseCreate = loadable(() => import('@/pages/License/Create'));
const LicenseDetail = loadable(() => import('@/pages/License/Detail'));
const LicenseEdit = loadable(() => import('@/pages/License/Edit'));

const OrderList = loadable(() => import('@/pages/Order/List'));
const OrderCreate = loadable(() => import('@/pages/Order/Create'));
const OrderDetail = loadable(() => import('@/pages/Order/Detail'));
const OrderEdit = loadable(() => import('@/pages/Order/Edit'));

const UnderConstruction = loadable(() => import('@/pages/UnderConstruction'));

const PatientList = loadable(() => import('@/pages/Patient/List'));
const PatientCreate = loadable(() => import('@/pages/Patient/Create'));
// const PatientCreateRHF = loadable(() => import('@/pages/Patient/Create'));
const PatientDetail = loadable(() => import('@/pages/Patient/Detail'));
const PatientEdit = loadable(() => import('@/pages/Patient/Edit'));
const PatientDetailPageSetting = loadable(() => import('@/pages/PatientDetailPageSetting'));
const PatientReportGenarate = loadable(() => import('@/pages/Patient/Report/ReportProcessor'));
const PatientRawReport = loadable(() => import('@/pages/Patient/Report/RawReportPage'));

const DeviceList = loadable(() => import('@/pages/Device/List'));
const DeviceCreate = loadable(() => import('@/pages/Device/Create'));
const DeviceDetail = loadable(() => import('@/pages/Device/Detail'));
const DeviceEdit = loadable(() => import('@/pages/Device/Edit'));

const LogList = loadable(() => import('@/pages/Log/List'));
const LogDetail = loadable(() => import('@/pages/Log/Detail'));

const IngestionMonitoring = loadable(() => import('@/pages/Monitoring/Ingestion'));

const Preference = loadable(() => import('@/pages/Preference'));

// [page] MEMBER
export const MEMBER = {
  path: routes.MEMBER.path,
  children: [
    {
      path: routes.MEMBER_LOGIN.path,
      element: <Login />,
    },
    {
      path: routes.MEMBER_FIND_ID.path,
      element: <FindAccount defaultTab="id" />,
    },
    {
      path: routes.MEMBER_FIND_ID_SUCCESS.path,
      element: <FindIdSuccess />,
    },
    {
      path: routes.MEMBER_RESET_PWD.path,
      element: <FindAccount defaultTab="pwd" />,
    },
    {
      path: routes.MEMBER_NEWPWD.path,
      element: <NewPWD />,
    },
  ],
};

// [page] HOME
export const HOME = {
  redirect: routes.MEMBER_LOGIN.path,
  path: routes.HOME.path,
  element: <BaseLayout />,
  children: [{ path: routes.HOME.path, element: <Home /> }],
};

// [page] ORGANIZATION
export const ORGANIZATION = {
  path: routes.ORGANIZATION.path,
  element: <BaseLayout />,
  children: [
    { path: routes.ORGANIZATION.path, element: <OrganizationList /> },
    { path: routes.ORGANIZATION_CHART.path, element: <OrganizationChart /> },
    { path: routes.ORGANIZATION_CREATE.path, element: <OrganizationCreateRHF /> },
    { path: routes.ORGANIZATION_DETAIL.path, element: <OrganizationDetail /> },
    { path: routes.ORGANIZATION_EDIT.path, element: <OrganizationEditRHF /> },
  ],
};

// [page] User
export const USER = {
  path: routes.USER.path,
  element: <BaseLayout />,
  children: [
    { path: routes.USER.path, element: <UserList /> },
    { path: routes.USER_CREATE.path, element: <UserCreate /> },
    // J: Create with react-hook-form
    { path: routes.USER_CREATE_RHF.path, element: <UserCreateRHF /> },
    { path: routes.USER_DETAIL.path, element: <UserDetail /> },
    { path: routes.USER_EDIT.path, element: <UserEdit /> },
    // J: Edit with react-hook-form
    { path: routes.USER_EDIT_RHF.path, element: <UserEditRHF /> },
  ],
};

// [page] Role
export const ROLE = {
  path: routes.ROLE.path,
  element: <BaseLayout />,
  children: [
    { path: routes.ROLE.path, element: <RoleList /> },
    { path: routes.ROLE_CREATE.path, element: <RoleCreate /> },
    { path: routes.ROLE_DETAIL.path, element: <RoleDetail /> },
    { path: routes.ROLE_EDIT.path, element: <RoleEdit /> },
  ],
};

// [page] Function
export const FUNCTION = {
  path: routes.FUNCTION.path,
  element: <BaseLayout />,
  children: [
    { path: routes.FUNCTION.path, element: <FunctionList /> },
    { path: routes.FUNCTION_CREATE.path, element: <FunctionCreate /> },
    { path: routes.FUNCTION_DETAIL.path, element: <FunctionDetail /> },
    { path: routes.FUNCTION_EDIT.path, element: <FunctionEdit /> },
  ],
};

// [page] Menu
export const MENU = {
  path: routes.MENU.path,
  element: <BaseLayout />,
  children: [
    { path: routes.MENU.path, element: <MenuList /> },
    { path: routes.MENU_CREATE.path, element: <MenuCreate /> },
    { path: routes.MENU_DETAIL.path, element: <MenuDetail /> },
    { path: routes.MENU_EDIT.path, element: <MenuEdit /> },
  ],
};

// [page] Resource
export const RESOURCE = {
  path: routes.RESOURCE.path,
  element: <BaseLayout />,
  children: [
    { path: routes.RESOURCE.path, element: <ResourceList /> },
    { path: routes.RESOURCE_CREATE.path, element: <ResourceCreate /> },
    { path: routes.RESOURCE_DETAIL.path, element: <ResourceDetail /> },
    { path: routes.RESOURCE_EDIT.path, element: <ResourceEdit /> },
  ],
};

// [page] GroupCode
export const GROUP_CODE = {
  path: routes.GROUP_CODE.path,
  element: <BaseLayout />,
  children: [
    { path: routes.GROUP_CODE.path, element: <GroupCodeList /> },
    { path: routes.GROUP_CODE_CREATE.path, element: <GroupCodeCreate /> },
    // J: Create with react-hook-form
    { path: routes.GROUP_CODE_CREATE_RHF.path, element: <GroupCodeCreateRHF /> },
    { path: routes.GROUP_CODE_DETAIL.path, element: <GroupCodeDetail /> },
    { path: routes.GROUP_CODE_EDIT.path, element: <GroupCodeEdit /> },
    // J: Update with react-hook-form
    { path: routes.GROUP_CODE_EDIT_RHF.path, element: <GroupCodeEditRHF /> },
  ],
};

// [page] DetailCode
export const DETAIL_CODE = {
  path: routes.DETAIL_CODE.path,
  element: <BaseLayout />,
  children: [
    { path: routes.DETAIL_CODE.path, element: <DetailCodeList /> },
    { path: routes.DETAIL_CODE_CREATE.path, element: <DetailCodeCreate /> },
    // J: Create with react-hook-form
    { path: routes.DETAIL_CODE_CREATE_RHF.path, element: <DetailCodeCreateRHF /> },
    { path: routes.DETAIL_CODE_DETAIL.path, element: <DetailCodeDetail /> },
    { path: routes.DETAIL_CODE_EDIT.path, element: <DetailCodeEdit /> },
    // J: Update with react-hook-form
    { path: routes.DETAIL_CODE_EDIT_RHF.path, element: <DetailCodeEditRHF /> },
  ],
};

// [page] fallback
export const FALLBACK = {
  path: routes.PAGE_ERROR_DEFAULT.path,
  element: <Navigate replace to={DEFAULT_INIT_PAGE} />,
};

// [page] ACCOUNT
export const ACCOUNT = {
  path: routes.ACCOUNT.path,
  element: <BaseLayout />,
  children: [{ path: routes.ACCOUNT.path, element: <Account /> }],
};

// [page] PREFERENCE
export const PREFERENCE = {
  path: routes.PREFERENCE.path,
  element: <BaseLayout />,
  children: [{ path: routes.PREFERENCE.path, element: <Preference /> }],
};

// [page] SYSSETTINGS
export const SYS_SETTING = {
  path: routes.SYS_SETTING.path,
  element: <BaseLayout />,
  children: [
    { path: routes.SYS_SETTING.path, element: <SysSettingList /> },
    { path: routes.SYS_SETTING_CREATE.path, element: <SysSettingCreate /> },
    { path: routes.SYS_SETTING_DETAIL.path, element: <SysSettingDetail /> },
    { path: routes.SYS_SETTING_EDIT.path, element: <SysSettingEdit /> },
  ],
};

// [page] SERVERS
export const SERVERS = {
  path: routes.SERVERS.path,
  element: <BaseLayout />,
  children: [
    { path: routes.SERVERS.path, element: <ServersList /> },
    { path: routes.SERVERS_CREATE.path, element: <ServersCreate /> },
    // J: Create with react-hook-form
    { path: routes.SERVERS_CREATE_RHF.path, element: <ServersCreateRHF /> },
    { path: routes.SERVERS_DETAIL.path, element: <ServersDetail /> },
    { path: routes.SERVERS_EDIT.path, element: <ServersEdit /> },
  ],
};
// [page] LICENSE
export const LICENSE = {
  path: routes.LICENSE.path,
  element: <BaseLayout />,
  children: [
    { path: routes.LICENSE.path, element: <LicenseList /> },
    { path: routes.LICENSE_CREATE.path, element: <LicenseCreate /> },
    { path: routes.LICENSE_DETAIL.path, element: <LicenseDetail /> },
    { path: routes.LICENSE_EDIT.path, element: <LicenseEdit /> },
  ],
};

// [page] ORDERS
export const ORDER = {
  path: routes.ORDER.path,
  element: <BaseLayout />,
  children: [
    { path: routes.ORDER.path, element: <OrderList /> },
    { path: routes.ORDER_CREATE.path, element: <OrderCreate /> },
    { path: routes.ORDER_DETAIL.path, element: <OrderDetail /> },
    { path: routes.ORDER_EDIT.path, element: <OrderEdit /> },
  ],
};

export const ERROR_404 = {
  path: routes.ERROR_404.path,
  element: <Custom404 />,
};

// [page] PATIENT
export const PATIENT = {
  path: routes.PATIENT.path,
  element: <BaseLayout />,
  children: [
    { path: routes.PATIENT.path, element: <PatientList /> },
    { path: routes.PATIENT_CREATE.path, element: <PatientCreate /> },
    { path: routes.PATIENT_DETAIL.path, element: <PatientDetail /> },
    { path: routes.PATIENT_EDIT.path, element: <PatientEdit /> },
    // { path: routes.PATIENT_DETAIL_SETTING.path, element: <PatientDetailPageSetting /> },
  ],
};

// [page] PAGE_SETTING
export const PAGE_SETTING = {
  path: routes.PATIENT_DETAIL_SETTING.path,
  element: <BaseLayout />,
  children: [{ path: routes.PATIENT_DETAIL_SETTING.path, element: <PatientDetailPageSetting /> }],
};

// [page] REPORT
export const REPORT = {
  path: routes.REPORT_PATIENT.path,
  children: [
    { path: routes.REPORT_PATIENT.path, element: <PatientReportGenarate /> },
    { path: routes.RAW_REPORT_PATIENT.path, element: <PatientRawReport /> },
  ],
};

// [page] DEVICE
export const DEVICE = {
  path: routes.DEVICE.path,
  element: <BaseLayout />,
  children: [
    { path: routes.DEVICE.path, element: <DeviceList /> },
    { path: routes.DEVICE_CREATE.path, element: <DeviceCreate /> },
    { path: routes.DEVICE_DETAIL.path, element: <DeviceDetail /> },
    { path: routes.DEVICE_EDIT.path, element: <DeviceEdit /> },
  ],
};

// [page] LOG
export const LOG = {
  path: routes.LOG.path,
  element: <BaseLayout />,
  children: [
    { path: routes.LOG.path, element: <LogList /> },
    { path: routes.LOG_DETAIL.path, element: <LogDetail /> },
  ],
};

// [page] MONITORING
export const MONITORING = {
  path: routes.MONITORING.path,
  element: <BaseLayout />,
  children: [{ path: routes.MONITORING_INGEST.path, element: <IngestionMonitoring /> }],
};

export const UNDER_CONSTRUCTION = {
  path: routes.UNDER_CONSTRUCTION.path,
  element: <BaseLayout />,
  children: [{ path: routes.UNDER_CONSTRUCTION.path, element: <UnderConstruction /> }],
};

const routeInfo = [
  HOME,
  MEMBER,
  USER,
  ROLE,
  FUNCTION,
  MENU,
  RESOURCE,
  GROUP_CODE,
  DETAIL_CODE,
  ACCOUNT,
  PREFERENCE,
  ERROR_404,
  FALLBACK,
  SYS_SETTING,
  ORGANIZATION,
  SERVERS,
  LICENSE,
  ORDER,
  UNDER_CONSTRUCTION,
  PATIENT,
  DEVICE,
  PAGE_SETTING,
  REPORT,
  LOG,
  MONITORING,
];

export default routeInfo;
